// extracted by mini-css-extract-plugin
export var acitonButtons = "_i0-0";
export var additionalIcon = "_i0-f";
export var block = "_i0-1";
export var blockContent = "_i0-7";
export var blockDescription = "_i0-8";
export var blockIcon = "_i0-9";
export var blockTitle = "_i0-6";
export var border = "_i0-a";
export var center = "_i0-l";
export var edge = "_i0-b";
export var edgeLabel = "_i0-c";
export var edgePath = "_i0-d";
export var error = "_i0-e";
export var flowchart = "_i0-g";
export var flowchartContent = "_i0-h";
export var highlighted = "_i0-3";
export var hover = "_i0-4";
export var icon = "_i0-i";
export var left = "_i0-m";
export var navButton = "_i0-j";
export var navButtons = "_i0-k";
export var right = "_i0-n";
export var selected = "_i0-2";
export var small = "_i0-5";